/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from 'react'
import { Button, Flex, Text, Tooltip, rem } from '@mantine/core'
import ImageObserved from '../pipeline/Image'
import { PipelineParameters } from '../pipeline/Pipeline'
import { NOTIFICATION_SERVICE } from '../../../components/notifications/NotificationService'
import CanvasDraw from "react-canvas-draw";
import { useStore } from '../../../hooks/use-store'
import { observer } from 'mobx-react'
import { useRequest } from 'ahooks'
import { priceMap } from '../pipeline/Router'
import { useHistory } from 'react-router-dom'

function RemoveObject(model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) {

  const {
    dataStore: { spaceStore, appStore },
  } = useStore();


  useEffect(() => {
    if (spaceStore.selectedImage) {
      const img = new Image();
      img.onload = function () {
        // max width 1200
        // max height 1200 
        // with ratio
        const width = img.width
        const height = img.height
        const ratio = width / height
        if (width > height) {
          setWidth(1200)
          setHeight(1200 / ratio)
        }
        if (height > width) {
          setHeight(1200)
          setWidth(1200 * ratio)
        }
        if (width === height) {
          setWidth(1200)
          setHeight(1200)
        }
      }
      console.log(spaceStore.selectedImage)
      setBackground(spaceStore.selectedImage)
      img.src = spaceStore.selectedImage
    }
  }, [spaceStore.selectedImage])

  const history = useHistory()
  const renderRef = useRef<CanvasDraw>(null);
  const [width, setWidth] = useState(1000)
  const [height, setHeight] = useState(1000)
  const [background, setBackground] = useState('')
  const [selectedSize, setSelectedSize] = useState<'1K' | '2K' | '4K'>('4K')
  const sizeMultiplier = selectedSize === '1K' ? 1 : selectedSize === '2K' ? 2 : 4
  const computedCredits = priceMap.REMOVE_OBJECT * sizeMultiplier

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading: runAsyncConvertBase64Loading, runAsync: runAsyncConvertBase64 } = useRequest(
    async (model: { url: string }) => appStore.convertImageBase64({
      url: model.url,
    }),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          return res.url
        }
      },
    }
  );
  // const [prompt, setPrompt] = useState('')
  return (
    <Flex w={'100%'} mt={12} pt={32} pb={32} pl={40} pr={40} style={{ borderRadius: '4px', background: 'rgba(32, 32, 32, 1)' }} gap={32} pos='relative'>
      <Flex pos='absolute' top='0' right='0' style={{ cursor: 'pointer' }} onClick={() => {
        history.push('/history')
      }}>
        <svg width="40" height="40" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.17157 11.2944L10.8284 5.63758" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.8284 11.2945L5.17157 5.6377" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </Flex>
      <Flex direction={'column'} w={'40%'} gap={12}>

        <Text fz={32} fw={800} color='#fff' lh={1.2} mb={12}>Remove the Car.<br/> Keep the Scene.
        </Text>
        <Text fz={16} color='#fff' lh={1.4} maw={440}>
          Turn any generated image into a clean backplate. Ready for your CGI
          workflow.<Tooltip
          label={
            <Text fw={500}>
              With the Remove Car function, you can automatically erase vehicles from your generated visuals. The result is a perfectly reconstructed backplate. Ideal for replacing the AI-generated car with your own 3D model.
            </Text>
          }
          multiline
          w={320}
          withArrow
          position="bottom"
          color='dark'
        >
          <span style={{ marginLeft: 4, cursor: 'pointer', display: 'inline-block' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="#4badf4" className="icon icon-tabler icons-tabler-filled icon-tabler-info-square-rounded"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" /></svg>
          </span>

        </Tooltip>
        </Text>

        <Flex direction="column" gap={12} mt={32}>
          <Flex gap={8} align="center" wrap="wrap" style={{ backgroundColor: 'rgba(32, 32, 32, 1)', borderRadius: '8px', padding: '8px' }}>
            <Text color="white" size="sm" fw={500}>Size:</Text>
            {(['1K', '2K', '4K'] as const).map((size) => (
              <Button
                key={size}
                size="xs"
                variant={selectedSize === size ? 'filled' : 'outline'}
                color={selectedSize === size ? 'orange' : 'gray'}
                onClick={() => setSelectedSize(size)}
                style={{ minWidth: '48px' }}
              >
                {size}
              </Button>
            ))}
          </Flex>
          <Tooltip
            p={12}
            label={
              <span>Generation cost:
                &nbsp;
                <span style={{
                  color: '#f53c02',
                  fontWeight: 700
                }}>{computedCredits} credits
                </span>
              </span>
            }
            withArrow
            position="right"
            color='dark'
          >
            <Button
              styles={{
                root: {
                  color: 'rgba(230, 230, 230, 1)',
                  height: rem(36),

                  fontSize: '14px',
                  background: '#f53c02 !important',
                  border: 'none',
                  position: 'relative',
                },
              }}
              variant="default"
              onClick={async () => {

                const pipeline: PipelineParameters = {
                  provider: 'custom',
                  type: 'removeObject2',
                  prompt: 'The car should be removed. The background should be kept unchanged.',
                  inputSrc: background,
                  maskSrc: '',
                  credits: computedCredits,
                  size: selectedSize,
                  srcset: [],
                }
                await model.buy([pipeline]);
              }}
            >
              Remove Car
            </Button>
          </Tooltip>
        </Flex>
      </Flex>
      <Flex justify={'center'} direction={'column'} align={'center'} w={'60%'}>
        <ImageObserved
          width={'100%'}
          height={'100%'}
          dark
          src={spaceStore.selectedImage!}
        />
      </Flex>
    </Flex>

    // <Flex w={'100%'} mt={12} pt={16} pb={16} pl={20} pr={20} style={{ borderRadius: '4px',background: 'rgba(32, 32, 32, 1)'   }} gap={32}>

    //   <Flex direction={'column'} miw={'300px'} w={'100%'} gap={12}>
    //     <Text fz={20}>Remove car</Text>
    //     <Text fz={12}>select the car with brush</Text>
    //     {
    //       background ? <Flex
    //         w={width + 'px'}
    //         h={height + 'px'}
    //         style={{
    //           position: 'relative',
    //         }}
    //       >
    //         <div
    //           style={{
    //             position: 'relative',
    //             zIndex: 1,
    //             width: '100%',
    //             height: '100%',
    //             background: 'rgba(0,0,0,0.2)',
    //           }}

    //         >
    //           <CanvasDraw
    //             ref={renderRef}
    //             backgroundColor='#00000028'
    //             lazyRadius={0}
    //             hideGrid={true}
    //             brushRadius={30}
    //             brushColor={'#ffff'}
    //             canvasWidth={width}
    //             canvasHeight={height}
    //           />
    //         </div>
    //         <ImageObserved
    //           style={{
    //             background: '#2424263f',
    //             position: 'absolute',
    //             borderRadius: '4px',
    //             left: 0,
    //             padding: 0,
    //           }}
    //           width={width + 'px'}
    //           height={height + 'px'}
    //           dark
    //           objectFit='cover'
    //           src={background}
    //         />

    //       </Flex> : null
    //     }

    //     <Flex gap={12} mt={32}  justify={'center'}>
    //       <Button
    //         styles={{
    //           root: {
    //             color: 'rgba(230, 230, 230, 1)',
    //             height: rem(36),

    //             fontSize: '14px',
    //             background: `#f53c02 !important`,
    //             border: 'none',
    //             position: 'relative',
    //           }
    //         }}
    //         variant="default"
    //         onClick={async () => {

    //           if (renderRef) {
    //             const image = renderRef.current?.getDataURL('image/png', false, '#000')
    //             const { url } = await runAsyncConvertBase64({ url: image })
    //             console.log(url)

    //             // NEW
    //             const pipeline: PipelineParameters = {
    //               provider: 'custom',
    //               type: 'removeObject2',
    //               prompt: 'Car',
    //               inputSrc: background,
    //               maskSrc: url,
    //               credits: priceMap.REMOVE_OBJECT,
    //               srcset: [],
    //             }
    //             await model.buy([pipeline]);
    //           }
    //         }}
    //       >
    //         Run
    //       </Button>
    //     </Flex>
    //   </Flex>

    // </Flex>
  )
}

export default observer(RemoveObject);